import React, { useContext } from 'react'
import { Redirect, Route } from 'react-router';
import { GAuthContext } from '../App';

function PrivateRoute({ children, ...rest }) {
    const gAuth = useContext(GAuthContext);

    return (
        <Route
            {...rest}
            render={({ location }) =>
                gAuth.loggedIn ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: "/",
                            state: { from: location }
                        }}
                    />
                )
            }
        />
    );
}

export default PrivateRoute
